<template>
  <div style="margin-top:10px;">
    <h1 style="margin-top:unset;">Customers Devices</h1>
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :md="{ span: 18, offset: 3 }">
        <el-row :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="10" :offset="7">
            <el-autocomplete
              v-model="searchText"
              :fetch-suggestions="remoteMethodSearchShop"
              :disabled="selectAllShopSearch"
              placeholder="ค้นหาชื่อร้าน, เบอร์โทรร้าน, Email ร้าน, Usercode"
              style="width: 100%;"
              @select="handleSelect"
              @focus="$event.target.select()"
            >
              <template slot-scope="{ item }">
                <span>{{ item.data.name }}</span>
              </template>
              <i class="el-input__icon el-icon-search" slot="prefix"></i>
            </el-autocomplete>
          </el-col>
          <el-col :span="3">
            <el-checkbox
              v-model="selectAllShopSearch"
              :disabled="onSearchDisable"
              border
              label="ร้านค้าทั้งหมด"
              @change="changeSelectAllShop"
            >
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10" :offset="7">
            <el-date-picker
              v-model="datePicked"
              :disabled="onSearchDisable"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-button
              :disabled="onSearchDisable"
              type="primary"
              @click="onDatePicked()"
              >ดำเนินการ</el-button
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :md="{ span: 20, offset: 2 }">
        <el-card shadow="never" style="padding-bottom:20px;">
          <el-row>
            <el-col class="text-md-center" :span="24">
              <el-table
                v-loading="loadingTable"
                :data="userData"
                :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
              >
               <el-table-column
                  label="SHOP NAME"
                  sortable
                  prop="shopName"
                  width="250"
                ></el-table-column>
                <el-table-column label="USER DEVICES">
                  <template slot-scope="props">
                    <div class="username-Pich">
                      <span>
                        <b>User name : {{ props.row.user.userFullName }}</b>
                      </span>
                    </div>
                    <div
                      class="deviceInfo"
                      v-for="(device, index) in props.row.user.devices"
                      :key="index"
                    >
                      <el-tooltip
                        :content="
                          'Architecture : ' + device.os.architecture + ' bit'
                        "
                        effect="dark"
                        placement="top-start"
                      >
                        <img
                          class="deviceIcon"
                          :src="getarchitectureImg(device.os.architecture)"
                        />
                      </el-tooltip>

                      <el-tooltip
                        :content="
                          'OS version : ' +
                            device.os.family +
                            ' ' +
                            device.os.version
                        "
                        effect="dark"
                        placement="top-start"
                      >
                        <img
                          class="deviceIcon"
                          :src="getOsImg(device.os.family)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        :content="device.description"
                        effect="dark"
                        placement="top-start"
                      >
                        <img
                          class="deviceIcon"
                          :src="getBrowserImg(device.description)"
                        />
                      </el-tooltip>
                      <span class="resolution">
                        <b>Res : {{ device.resolution | resFilter }}</b>
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="EMPLOYEES">
                  <template slot-scope="props">
                    <div
                      v-for="(emp, index) in props.row.employees"
                      :key="index"
                    >
                      <div class="empId">
                        <span>
                          <b>Employee name : {{ emp.empFullName }}</b>
                        </span>
                      </div>
                      <div
                        class="deviceInfo"
                        v-for="(empDevice, index) in emp.devices"
                        :key="index"
                        style="padding-top:5px;"
                      >
                        <el-tooltip
                          :content="
                            'Architecture : ' +
                              empDevice.os.architecture +
                              ' bit'
                          "
                          effect="dark"
                          placement="top-start"
                        >
                          <img
                            class="deviceIcon"
                            :src="getarchitectureImg(empDevice.os.architecture)"
                          />
                        </el-tooltip>

                        <el-tooltip
                          :content="
                            'OS version : ' +
                              empDevice.os.family +
                              ' ' +
                              empDevice.os.version
                          "
                          effect="dark"
                          placement="top-start"
                        >
                          <img
                            class="deviceIcon"
                            :src="getOsImg(empDevice.os.family)"
                          />
                        </el-tooltip>

                        <el-tooltip
                          :content="empDevice.description"
                          effect="dark"
                          placement="top-start"
                        >
                          <img
                            class="deviceIcon"
                            :src="getBrowserImg(empDevice.description)"
                          />
                        </el-tooltip>
                        <span class="resolution">
                          <b>Res : {{ empDevice.resolution | resFilter }}</b>
                        </span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="24" style="margin-top:10px;">
              <el-pagination
                 @size-change="changeLimitPage"
                 @current-change="changeCurrentPage"
                 :current-page.sync="pagination.currentPage"
                 :page-sizes="pagination.pageSizes"
                 :page-size="10"
                 layout="prev, pager, next, sizes"
                 :total="pagination.allPage * pagination.limit">
              ></el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import { setTimeout } from 'timers'
export default {
    name: 'DashboardCustomers',
    filters: {
        resFilter (resolution) {
            return (
                resolution.split('x')[0].split('.')[0] +
        'x' +
        resolution.split('x')[1].split('.')[0]
            )
        }
    },
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            selectAllShopSearch: true,
            onSearchDisable: false,
            loadingTable: null,
            timeoutSearch: null,
            timeout: null,
            shopId: '',
            searchText: '',
            userData: [],
            datePicked: [
                this.$dayjs(new Date())
                    .subtract(14, 'day')
                    .format('YYYY-MM-DD'),
                this.$dayjs(new Date()).format('YYYY-MM-DD')
            ],
            architectureList: [
                {
                    id: 0,
                    logoPath: require('@/assets/devices/32bit.jpg'),
                    label: '32bit'
                },
                {
                    id: 1,
                    logoPath: require('@/assets/devices/64bit.jpg'),
                    label: '64bit'
                }
            ],
            osList: [
                {
                    id: 0,
                    logoPath: require('@/assets/devices/window_logo.png'),
                    label: 'Windows'
                },
                {
                    id: 1,
                    logoPath: require('@/assets/devices/linux_logo.png'),
                    label: 'Linux'
                },
                {
                    id: 2,
                    logoPath: require('@/assets/devices/OS X.png'),
                    label: 'OS X'
                },
                {
                    id: 3,
                    logoPath: require('@/assets/devices/Android.png'),
                    label: 'Android'
                },
                {
                    id: 4,
                    logoPath: require('@/assets/devices/apple_logo.png'),
                    label: 'iOS'
                }
            ],
            browserList: [
                {
                    id: 0,
                    logoPath: require('@/assets/devices/Chrome.png'),
                    label: 'Chrome'
                },
                {
                    id: 1,
                    logoPath: require('@/assets/devices/Safari.png'),
                    label: 'Safari'
                },
                {
                    id: 2,
                    logoPath: require('@/assets/devices/Firefox.png'),
                    label: 'Firefox'
                }
            ]
        }
    },
    created () {
        this.fetchCustomerDevices()
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchCustomerDevices()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchCustomerDevices()
        },
        fetchCustomerDevices () {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(async () => {
                this.loadingTable = true
                this.onSearchDisable = true
                let param = {
                    from: this.datePicked[0],
                    to: this.datePicked[1],
                    // shop_id: this.shopId,
                    // search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset
                }
                if (this.shopId !== '') {
                    param['shop_id'] = this.shopId
                }
                console.log('param', param)
                try {
                    let res = await fgApi.dashboard.getUserDevices(param)
                    console.log('res : ', res)
                    if (res.success) {
                        this.userData = res.data
                        this.pagination.allPage = res.allPage
                        console.log('userData : ', this.userData)
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
                this.loadingTable = false
                this.onSearchDisable = false
            }, 500)
        },
        remoteMethodSearchShop (text, cb) {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                let param = {
                    search: this.searchText // customer code
                }
                let shopIdRes = await fgApi.dashboard.getShopIdByUserCode(param)
                console.log('shopIdRes', shopIdRes)
                try {
                    if (shopIdRes.success) {
                        let searchResult = []
                        shopIdRes.data.forEach(e => {
                            searchResult.push({
                                value: e.id,
                                label: e.name,
                                data: e
                            })
                        })
                        cb(searchResult)
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
            }, 500)
        },
        changeSelectAllShop () {
            if (this.selectAllShopSearch === true) {
                this.searchText = ''
                this.shopId = ''
                this.fetchCustomerDevices()
            } else {
                this.userData = []
                this.$message({
                    showClose: true,
                    message: 'Warning, Please select shop',
                    type: 'warning'
                })
            }
        },
        handleSelect (val) {
            console.log('val:', val)
            this.pagination = {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
            this.searchText = val.label
            this.shopId = val.value
            this.fetchCustomerDevices()
        },
        onDatePicked () {
            console.log('date : ', this.datePicked)
            if (this.datePicked === null) {
                this.datePicked = [
                    this.$dayjs(new Date())
                        .subtract(14, 'day')
                        .format('YYYY-MM-DD'),
                    this.$dayjs(new Date()).format('YYYY-MM-DD')
                ]
                this.fetchCustomerDevices()
            } else {
                this.fetchCustomerDevices()
            }
        },
        getarchitectureImg (value) {
            let str = String(value)
            if (str.search(/32/i) >= 0) {
                return this.architectureList[0].logoPath
            } else if (str.search(/64/i) >= 0) {
                return this.architectureList[1].logoPath
            } else {
                return require('@/assets/devices/xmark.png')
            }
        },
        getOsImg (value) {
            let str = String(value)
            if (value.search(/windows/i) >= 0) {
                return this.osList[0].logoPath
            } else if (str.search(/linux/i) >= 0) {
                return this.osList[1].logoPath
            } else if (str.search(/os x/i) >= 0) {
                return this.osList[2].logoPath
            } else if (str.search(/android/i) >= 0) {
                return this.osList[3].logoPath
            } else if (str.search(/ios/i) >= 0) {
                return this.osList[4].logoPath
            } else {
                return require('@/assets/devices/xmark.png')
            }
        },
        getBrowserImg (value) {
            let str = String(value)
            if (str.search(/chrome/i) >= 0) {
                return this.browserList[0].logoPath
            } else if (str.search(/safari/i) >= 0) {
                return this.browserList[1].logoPath
            } else if (str.search(/firefox/i) >= 0) {
                return this.browserList[2].logoPath
            } else {
                return require('@/assets/devices/xmark.png')
            }
        }
    }
}
</script>

<style lang="scss" >
.dataTable {
  th {
    background-color: black;
    color: white;
  }
}
.deviceInfo {
  background-color: rgb(222, 240, 173);
  border-radius: 2%;
  padding: 12px;
  border-bottom: 2px solid rgb(248, 248, 248);
}
.username-Pich {
  color: white;
  background-color: #303133;
  padding: 10px;
  margin-top: 5px;
  border-radius: 2%;
}
.empId {
  color: white;
  background-color: #303133;
  padding: 10px;
  margin-top: 5px;
  border-radius: 2%;
}
.deviceIcon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.resolution {
  background-color: rgb(236, 212, 181);
  color: rgb(163, 50, 50);
  border: 1px solid rgb(124, 24, 24);
  padding: 5px;
  border-radius: 5%;
}
.highlight {
  font-weight: bold;
  background: yellow;
}
</style>
